import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';
import { inline } from 'app/shared/styles/_spacing';
import { zindex } from 'app/shared/styles/_zindex';

import MapViewBase from 'app/shared/modules/MobileSRP/Map/MapView';

// Types
import type { LoadingBannerProps } from './LoadingBanner';

interface MapButtonProps {
  $previewListingButtonPosition: boolean;
}
export const MapButton = styled.button<MapButtonProps>`
  position: fixed;
  right: 8px;
  bottom: 24px;
  border-radius: 100px;
  background: ${colors['$hpx-white']};
  box-shadow: 0 8px 18px 0 rgb(0 0 0 / 40%);
  padding: 12px 16px;
  width: 90px;
  z-index: ${zindex['$z-index-step-over']};

  ${(props) =>
    props.$previewListingButtonPosition &&
    `
        bottom: 210px;
    `}
`;

export const MapIcon = styled.img`
  ${inline._1x};
`;

export const MapView = styled(MapViewBase)``;

export const InteriorView = styled.div`
  position: absolute;
  background: white;
  top: 0;
  height: calc(100dvh - 92px);
  width: 100vw;
`;

export const StyledLoadingBanner = styled.div<LoadingBannerProps>`
  position: absolute;
  background: #212a3b;
  top: 8px;
  z-index: 500;
  width: 100vw;
  padding: 16px;
  color: white;
  font-weight: bold;
  @keyframes fadeOut {
    from {
      visibility: visible;
      opacity: 1;
    }
    to {
      visibility: hidden;
      opacity: 0;
    }
  }
  ${(props) => props.isMwebMapLoaded === true && `animation: fadeOut ease-in-out 0.5s forwards;`}
`;
